module.exports = __webpack_public_path__ + "static/media/05.1fa48133.png";